export default __webpack_public_path__ + "static/media/brakekit-blue.b7f1b73a.webp";